import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AuthShell } from "@/components/AuthShell";
import { api, errMsg } from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "loading", msg: "" });
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    api.post("/auth/verify-email", { token: params.get("token") || "" })
      .then(() => setState({ status: "ok" }))
      .catch((e) => setState({ status: "error", msg: errMsg(e) }));
  }, [params]);

  return (
    <AuthShell title="Conferma email" testId="verify-email-page">
      {state.status === "loading" && <div className="flex justify-center py-8"><Loader2 className="h-6 w-6 animate-spin text-[#0F2D5E]" /></div>}
      {state.status === "ok" && (
        <div className="text-center" data-testid="verify-email-success">
          <CheckCircle2 className="mx-auto h-14 w-14 text-[#15803D]" />
          <p className="mt-4 text-[#495850]">Email confermata. Ora puoi accedere al tuo account.</p>
          <Button asChild className="mt-8 h-12 w-full rounded-full bg-[#0F2D5E] hover:bg-[#0B2250]" data-testid="verify-email-login-btn"><Link to="/accedi">Accedi</Link></Button>
        </div>
      )}
      {state.status === "error" && (
        <div className="text-center" data-testid="verify-email-error">
          <XCircle className="mx-auto h-14 w-14 text-red-600" />
          <p className="mt-4 text-[#495850]">{state.msg}. Se l'account non è ancora confermato, prova ad accedere: potrai richiedere una nuova email.</p>
          <Button asChild className="mt-8 h-12 w-full rounded-full bg-[#0F2D5E] hover:bg-[#0B2250]"><Link to="/accedi">Vai al login</Link></Button>
        </div>
      )}
    </AuthShell>
  );
}
